import { createSelector } from 'reselect'

const getStudentViewData = state => state.student

const getStudentSessionType = createSelector(
	[ getStudentViewData ],
	student => student.sessionType
)

export default getStudentSessionType
